
















import Vue from 'vue'
import PortfolioMetadata from '@/components/PortfolioMetadata.vue'
import api from '@/api'
import store from '@/store'
import { ImageFile, Portfolio } from '../types'

export default Vue.extend({
  name: 'PortfolioDetail',

  components: {
    PortfolioMetadata,
  },

  computed: {
    photos(): Array<ImageFile> {
      return this.portfolio.images || []
    },
    portfolio(): Portfolio {
      return store.state.selectedPortfolio
    },
  },

  methods: {
    srcFor(image: ImageFile): string {
      if (!this.portfolio || !image) return ''

      return `${store.state.apiBaseUrl}/img/portfolio/${this.portfolio.id}/${image.remoteFilename}`
    },
  },

  async mounted() {
    if (Object.keys(store.state.selectedPortfolio).length === 0) {
      store.setSelectedPortfolio(await api.getPortfolio(this.$route.params.id))
    }
    window.scrollTo(0, 0)
  },
})
